import { useEffect } from 'react';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';

export const OAuthCallback = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'oauth-callback',
          code,
          state,
          error,
        },
        window.location.origin,
      );
    }

    window.close();
  }, []);

  return (
    <Container>
      <CircularProgress size={48} />
      <Message>연결 완료. 잠시 후 창이 닫힙니다.</Message>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
`;

const Message = styled.p`
  ${fonts.Body2};
  color: ${({ theme }) => theme.colors['text-gray-sub-dark']};
  margin: 0;
`;
